import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
let resError = ''

export const getTable = async ({
  token,
  //  company_id
}) => {
  try {
    return await clientPublic
      // .get(`professionalskill?company_id=${company_id}`, {
      .get(`professionalskill`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTableV2 = async ({
  token,
  //  company_id
}) => {
  try {
    return await clientPublicService
      // .get(`professionalskill?company_id=${company_id}`, {
      .get(`/core/management/professional-skill`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getResultCompany = async ({ token }) => {
  try {
    return await clientPublic
      .get('company', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const postData = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`professionalskill`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const postDataV2 = async ({ params, token }) => {
  try {
    return await clientPublicService
      .post(`/core/management/professional-skill`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateData = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`professionalskill/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateDataV2 = async ({ params, token }) => {
  try {
    return await clientPublicService
      .put(`/core/management/professional-skill`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deleteDataProfessionalskill = async ({ id, code, token }) => {
  try {
    return await clientPublic
      .delete(`professionalskill/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
